import { useState, useEffect } from "react";
import "../Modal.css";
import toast from "react-hot-toast";
import Swal from "sweetalert2";

const ModalEditOrderContact = ({ isVisible, onClose, orderId, products }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
  });

  // Only set initial values when modal opens
  useEffect(() => {
    if (isVisible) {
      setFormData({
        firstName: products?.firstName || "",
        lastName: products?.lastName || "",
        phoneNumber: products?.phoneNumber || "",
        email: products?.email || "",
      });
    }
  }, [isVisible]); // Removed `products` from dependencies to prevent overwriting user input

  // Handle input change
  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `https://server-gs.vercel.app/admin/order-contract-edit/${orderId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();
      if (response.ok) {
        Swal.fire({
          title: "Success!",
          text: "Contact Information updated successfully.",
          icon: "success",
          timer: 1500, // Auto-close after 1.5 seconds
          showConfirmButton: false, // No "OK" button
        });
        onClose(); // Close modal on success
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error("Failed to update order.");
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 flex justify-center items-center z-50">
      <div className="bg-gray-100 rounded-2xl shadow-2xl w-[600px] mx-5 sm:mx-auto overflow-hidden">
        {/* Header Section */}
        <div className="flex justify-between items-center py-4 px-6 bg-blue-600">
          <h2 className="text-xl font-semibold text-white">
            Update order contact
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-full hover:bg-blue-700 transition-colors duration-200"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Form Section */}
        <div className=" overflow-y-auto">
          <form onSubmit={handleSubmit}>
            <div className="p-6 space-y-6">
              {/* First Name */}
              <div>
                <label className="block font-roboto text-md text-gray-900 mb-2">
                  First Name
                </label>
                <input
                  type="text"
                  name="firstName"
                  placeholder="Enter first name"
                  value={formData.firstName}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                />
              </div>

              {/* Last Name */}
              <div>
                <label className="block font-roboto text-md text-gray-900 mb-2">
                  Last Name
                </label>
                <input
                  type="text"
                  name="lastName"
                  placeholder="Enter last name"
                  value={formData.lastName}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                />
              </div>

              {/* Phone Number */}
              <div>
                <label className="block font-roboto text-md text-gray-900 mb-2">
                  Phone Number
                </label>
                <input
                  type="text"
                  name="phoneNumber"
                  placeholder="Enter phone number"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                />
              </div>

              {/* Email */}
              <div>
                <label className="block font-roboto text-md text-gray-900 mb-2">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                />
              </div>
            </div>

            {/* Submit Button */}
            <div className="p-6 flex justify-start bg-gray-50 border-t border-gray-200">
              <button
                type="submit"
                className="w-56 py-3 font-roboto  bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg focus:ring-4 focus:outline-none focus:ring-blue-300 transition-all"
              >
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ModalEditOrderContact;
